<template>
  <div class="listview">
    <table>
      <thead class="none">
        <tr>
          <td class="listview__title items">DATE</td>
          <td class="listview__title placement">TYPE</td>
          <td class="listview__title dailyvisitor">DETAIL</td>
          <td class="listview__title dailyvisitor">AMOUNT</td>
          <td class="listview__title price">TOTAL COST</td>
        </tr>
      </thead>
      <tbody>
        <tr v-for="(item, index) in items" v-if="!loading" :key="index" class="content">
          <td class="date">
            <span>{{dateFormat(item.date)}}</span>
          </td>
          <td class="type"><span>{{item.code_type}}</span></td>
          <td class="detail">
            <h3 class="title">{{item.detail_title}}</h3>
            <span class="description">{{item.detail_description}}</span>
          </td>
          <td class="amount">
            <span>{{item.amount | formatMoney}}</span>
          </td>
          <td class="balance">{{item.balance | formatMoney}}</td>
        </tr>
      </tbody>
      <slot name="infiniteLoading"/>
    </table>
    <div class="emptyState">
      <adx-empty-selection v-if="isEmpty && !loading" />
    </div>
    <div class="listview__loadingWrapper">
      <slot name="loading" />
    </div>
  </div>
</template>

<script>
import EmptySelection from '@/components/NotFound/Selection'

import { mapGetters, mapActions, mapMutations } from 'vuex'
import api from '@/api'
import { apiV2 } from '@/api/urls'
import { formatShortDate } from '@/lib/util'

export default {
  name: 'adx-list-view',
  components: {
    'adx-empty-selection': EmptySelection
  },
  props: {
    items: {
      required: false
    },
    loading: {
      required: false
    }
  },
  data() {
    return {
      isEmpty: false
    }
  },
  updated() {
    if(this.items == 0) {
      this.isEmpty = true
    }else {
      this.isEmpty = false
    }
  },
  methods: {
    dateFormat(date) {
      return formatShortDate(date)
    }
  },
  computed: {
    
  }
}
</script>

<style lang='scss' scoped>
@import './index.scss';
</style>